import gql from 'graphql-tag';

const COUPON_SET_DELETE = gql`
mutation couponSetDeleteUnassigned($id: ID!){
  couponSetDeleteUnassigned(id: $id)
  
}
`;

export default COUPON_SET_DELETE;